<script setup>
import { computed, inject, ref, watch } from 'vue';
import StyledErrorMessage from '@/components/LayoutCompositions/StyledErrorMessage.vue';

const props = defineProps({
    habits: {
        type: Array,
        required: true,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    errorFormName: {
        type: String,
        default: '',
    }
});

const modals = inject('modals');

const form = ref(props.habits);

watch(() => props.habits, (value) => {
    form.value = value;
});

const addNumber = ()=>{
    form.value.push({
        id: `newHabit-${Date.now()+Math.random()}`,
        name: null,
        icon: null,
        count: 0,
    });
    reorderHabits();
};

const deleteHabit = async (habit)=>{
    const confirm = await modals.show('ConfirmationModal', {
        props: {
            title: 'Confirm Habit Removal',
            prompt: 'Press confirm to remove habit. The habit will be removed from the system after saving.'
        }
    });

    if (confirm) {
        if (!habit.id.toString().includes('newHabit')) {
            habit.destroy = true;
        } else {
            const index = form.value.findIndex(item => item.id === habit.id);
            if (index !== -1) {
                form.value.splice(index, 1);
            }
        }
        reorderHabits();
    }
};

const reorderHabits = ()=>{
    form.value.sort((a, b) => {
        if (a.destroy === b.destroy) {
            return 0;
        }
        return a.destroy ? 1 : -1;
    });
};

const filteredHabits = computed(()=>{
    return form.value.filter(obj => !obj.destroy);
});
</script>
<template>
<div>
    <div class="w-full col-span-2 flex flex-col border rounded-md border-grey-500 p-3">
        <v-table class="w-full col-span-2">
            <tbody>
                <tr v-for="(habit, index) in filteredHabits" :key="index"> 
                    <td class="">
                        <div class="flex gap-2 p-2 align-middle">
                            <StyledInput
                                v-model="habit.name"
                                class="mt-2"
                                :name="`${props.errorFormName}habits.${index}.name`"
                                :placeholder="$t('label.name')"
                                :label="$t('label.name')" />
                            <StyledButton
                                class="self-center"
                                color="secondary"
                                @click="deleteHabit(habit)">
                                <FontAwesomeIcon
                                    icon="remove" /> 
                            </StyledButton>
                        </div>
                    </td>
                </tr>
            </tbody>
        </v-table>
        <StyledButton
            v-if="!readonly"
            class="w-20 self-center mt-2 pt-0"
            density="compact"
            icon="plus"
            variant="outlined"
            @click="addNumber"><FontAwesomeIcon
                icon="plus" /></StyledButton>
        <StyledErrorMessage :name="`${props.errorFormName}habits`" :value="form" />
    </div>
</div>

</template>
